import { FC } from 'react'
import cx from 'classnames'
import { ImageProps } from 'next/image'

import { Icons } from '../Icon'
import { LinkProps } from '../Link'

import * as SC from './styled'
import { AdsCardVariant } from './styled'

export type AdsCardProps = {
  className?: string
  title?: string
  publicationDate?: string
  description?: string
  localization?: string
  offerType?: string
  offerTypeLink?: string
  adViewsNumber?: string
  adCommentNumber?: string
  link?: LinkProps
  variant?: AdsCardVariant
  layout?: 'default' | 'grid'
  media?: ImageProps
}

const AdsCard: FC<AdsCardProps> = ({
  className,
  title,
  publicationDate,
  description,
  localization,
  offerType,
  offerTypeLink,
  adViewsNumber,
  adCommentNumber,
  link,
  variant = AdsCardVariant.primary,
  layout = 'default',
  media,
}) => {
  const OfferType = offerTypeLink ? SC.OfferTypeLink : SC.OfferType
  const counters = (adViewsNumber || adCommentNumber) && (
    <SC.IconsWrapper>
      <SC.IconWrapper>
        <SC.IconEye icon={Icons.eye} width={24} height={24} />
        <SC.AdViewsNumber>{adViewsNumber}</SC.AdViewsNumber>
      </SC.IconWrapper>
      <SC.IconSeparator />
      <SC.IconWrapper>
        <SC.IconComment icon={Icons.comment} width={16} height={16} />
        <SC.AdCommentNumber>{adCommentNumber}</SC.AdCommentNumber>
      </SC.IconWrapper>
    </SC.IconsWrapper>
  )

  if (layout === 'grid') {
    return (
      <SC.GridCard className={cx('AdsCard', className)} $variant={variant}>
        <SC.GridHeadings>
          <SC.GridTitle>{title}</SC.GridTitle>
          <SC.PublicationDate $variant={variant} suppressHydrationWarning>
            {publicationDate}
          </SC.PublicationDate>
        </SC.GridHeadings>
        <SC.GridInfos>
          {[localization, offerType].filter(Boolean).join(' • ')}
        </SC.GridInfos>
        <SC.GridDivider />
        {media && (
          <SC.GridMedia>
            <SC.GridImage {...media} fill sizes="305px" />
          </SC.GridMedia>
        )}
        {description && (
          <SC.GridDescription $clamped={!!media}>
            {description}
          </SC.GridDescription>
        )}
        {(counters || link) && (
          <SC.GridAction>
            {counters}
            {link && (
              <SC.Lk {...link}>
                {link.text}
                <SC.IconArrowRight
                  icon={Icons.arrowRight}
                  width={16}
                  height={13}
                />
              </SC.Lk>
            )}
          </SC.GridAction>
        )}
      </SC.GridCard>
    )
  }

  return (
    <SC.AdsCard className={cx('AdsCard', className)} $variant={variant}>
      <SC.Title>{title}</SC.Title>
      <SC.PublicationDate $variant={variant} suppressHydrationWarning>
        {publicationDate}
      </SC.PublicationDate>
      <SC.TextSeparator $variant={variant} />
      {description && (
        <>
          <SC.Description $variant={variant}>{description}</SC.Description>
          <SC.TextSeparator $variant={variant} />
        </>
      )}
      <SC.Localization>{localization}</SC.Localization>
      {/* @ts-ignore */}
      <OfferType
        {...(offerTypeLink ? { href: offerTypeLink, target: '_blank' } : {})}
      >
        {offerType}
      </OfferType>
      <SC.Wrapper $description={description}>
        {counters}
        {link && (
          <SC.Lk {...link}>
            {link.text}
            <SC.IconArrowRight icon={Icons.arrowRight} width={16} height={13} />
          </SC.Lk>
        )}
      </SC.Wrapper>
    </SC.AdsCard>
  )
}

export default AdsCard
